module.exports = __webpack_public_path__ + "static/media/Ap1.da4569a6.png";